<template>
  <b-modal
    title="Create Member"
    header-bg-variant="success"
    header-text-variant="light"
    size="lg"
    :visible="showModal"
    centered
    @hidden="reset"
  >
    <b-form>


    <b-row>
      <h2 v-show="createOrgMembershipPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
      <pulse-loader :loading="createOrgMembershipPending" color="#489AAC" size="50px"></pulse-loader>
    </b-row>


      <b-form-select
      id='userId'
      size="lg"
      :options="getUserList(userList)"
      v-model="userId"
      >
        <option :value="null" disabled>-- Please select a user --</option>
      </b-form-select>

      <b-form-checkbox
        id="isOrgAdmin"
        v-model="isOrgAdmin"
        name="isOrgAdmin"
        :unchecked-value="false"
        switch
        inline
        class="m-3">
        Organization Admin - Would you like this user to be able to share, unshare and transfer records on behalf of
        your organization?
      </b-form-checkbox>

      <b-form-checkbox
        id="isManager"
        v-model="isManager"
        name="isManager"
        :unchecked-value="false"
        switch
        inline
        class="m-3">
        Organization Manager - Would you like this user to be able to view all of the records for your organization?
      </b-form-checkbox>

      <b-form-checkbox
        id="dwUser"
        v-model="isDWUser"
        name="dwUser"
        :unchecked-value="false"
        switch
        inline
        class="m-3">
          Data Warehouse User: Would you like this user to be able to access the Lighthouse Data Warehouse application?
      </b-form-checkbox>

      <b-form-checkbox
        id="careCoordinator"
        v-model="isCareCoordinator"
        name="careCoordinator"
        :unchecked-value="false"
        switch
        inline
        class="m-3">
        Care Coordinator: Would you like this user to access the Victim Identification tab designed for care coordinators?
      </b-form-checkbox>
    </b-form>

    <b-alert
      fade
      :show="createOrgMembershipFailure || _.isObject(createOrgMembershipSuccess)"
      :variant="createOrgMembershipFailure ? 'danger' : 'success'">
      <span v-html="apiResponseMessage()"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
    <span class="float-left text-danger"> <i>
    Note: Inactive users will not appear in the select list! </i>
    </span>
      <b-button type="button" variant="outline-primary" size="sm" class="float-right" @click="orgMemberHandler">
        <span class="button-text">Create</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CreateOrganizationsMemberModal',
  props: {
    orgId: Number,
    showModal: Boolean,
    existingUser: Array
  },
  data: function () {
    return {
      isManager: false,
      isOrgAdmin: false,
      userId: null,
      isDWUser: false,
      isCareCoordinator: false
    }
  },
  computed: {
    ...mapGetters({
      createOrgMembershipPending: 'getOrgCreateMemPending',
      createOrgMembershipSuccess: 'getOrgCreateMemSuccess',
      createOrgMembershipFailure: 'getOrgCreateMemFailure',
      userList: 'getAllUserList',
      dwLicenseAuth: 'getUserLicenseAuth',
      dwLicenseUsed: 'getUserLicenseUsed'
    })
  },
  watch: {
    createOrgMembershipSuccess (newValue) {
      this.userId = null
      if (this.showModal) {
        _.delay(this.clearForm, 1000)
        _.delay(this.reset, 1100)
      }
    }
  },
  methods: {
    getUserList: function (userList) {
      return _.sortBy(userList, 'fullName').filter((item) => {
        return !(this.existingUser && this.existingUser.indexOf(item.id) > -1) && item.active
      }).map((x) => {
        return {
          value: x.id,
          html: '<b>' + x.fullName + '</b> (' + x.emailAddress + ')'
        }
      })
    },
    reset: function () {
      this.$emit('update:showModal', false)
      this.clearForm()
    },
    orgMemberHandler () {
      if (this.userId && this.orgId) {
        this.$store.dispatch('createOrgUserMembership', {
          muser: this.userId,
          morganization: this.orgId,
          isOrgAdmin: this.isOrgAdmin,
          isManager: this.isManager,
          isDWUser: this.isDWUser,
          isCareCoordinator: this.isCareCoordinator
        })
      }
    },
    apiResponseMessage () {
      return (!this.createOrgMembershipFailure) ? 'Success' : '<p>' + this.createOrgMembershipFailure + '</p>'
    },
    clearForm () {
      this.$store.commit('resetOrgCreateMembership')
      this.isManager = false
      this.isOrgAdmin = false
      this.isDWUser = false
      this.isCareCoordinator = false
      this.userId = null
    }
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.$store.dispatch('getUserList', {})
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Admin/CreateOrganizationsMemberModal.vue